import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Button, Typography } from "@mui/material";

export const LoginButton: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = async () => {
    await loginWithRedirect({
      appState: { returnTo: "/" },
      authorizationParams: { prompt: "login" },
    });
  };

  return (
    <Button size="small" sx={{ m: 1, color: "inherit" }} onClick={handleLogin} fullWidth>
      <Typography variant="body2" fontWeight={"bold"}>
        Iniciar Sesión
      </Typography>
    </Button>
  );
};
